import * as Sentry from '@sentry/react'
import { useMutation } from '@tanstack/react-query'

import { logout } from '@/libs/auth'

export type LogoutHandler = () => Promise<void>

/**
 * ログアウト処理
 */
export const useLogout = (): LogoutHandler => {
  const { mutateAsync } = useMutation({
    mutationFn: async () => {
      await logout()
    },
    async onSuccess() {
      Sentry.setUser(null)
    },
    onError(error) {
      alert(error)
    }
  })
  return mutateAsync
}
